import { Link } from 'react-router-dom';

function RelayFamily(props) {
  return (
    <pre className="pre-scrollable">
      {props.family.map((value, index) => (
        <span
          key={index}
        >
          <Link to={"/details/" + value}>
            {value}
          </Link>
          {"\n"}
        </span>
      ))}
    </pre>
  )
}

export default RelayFamily;
